// Non-component types + defaults for the Drivers grid's bulk roster action,
// kept out of the .tsx so component files only export components
// (react-refresh friendliness — same split as `plan/components/planStyles.ts`).
import type { RosterScheduleType, RosterWorkingPattern } from '@my/directory-api';

/**
 * Bulk roster settings. Every field is optional — `''` means "keep whatever the
 * driver already has", which for a driver with no config yet means the roster
 * defaults (Full time · Monday–Friday). That way one bulk apply can onboard
 * hundreds of freshly imported drivers without disturbing the ones already set up.
 */
export interface BulkRosterValues {
  rosterGroupId: string;
  homeSiteId: string;
  startLocation: string;
  defaultStartTime: string;
  scheduleType: RosterScheduleType | '';
  workingPattern: RosterWorkingPattern | '';
}

export const EMPTY_BULK: BulkRosterValues = {
  rosterGroupId: '',
  homeSiteId: '',
  startLocation: '',
  defaultStartTime: '',
  scheduleType: '',
  workingPattern: '',
};
